/** Offline adviser meeting mode: clean client session UI on the local shortcut. */
const STORAGE_KEY = 'scp_presentation_mode';

export function isPresentationMode() {
  if (typeof window === 'undefined') return false;
  return localStorage.getItem(STORAGE_KEY) === '1';
}

/** Call before SubscriptionManager.initialize(). Handles ?presentation=1 on any entry URL. */
export function applyPresentationBootstrap() {
  if (typeof window === 'undefined') return;
  const params = new URLSearchParams(window.location.search);
  if (params.get('presentation') !== '1') return;

  localStorage.setItem(STORAGE_KEY, '1');
  localStorage.removeItem('simulate_free_user');
  // Fresh client session: do not revive a previous Advanced autosave ($500k defaults,
  // leftover MSI charts) beside newly typed balances in Adviser meetings.
  localStorage.removeItem('advanced_calculator_state');
  localStorage.removeItem('adv_saved_scenario');
  localStorage.removeItem('loadExample');
  localStorage.removeItem('loadExampleEditable');
  localStorage.removeItem('homepageAdvancedPrefill');

  const practice = (params.get('practice') || '').trim();
  if (practice) {
    localStorage.setItem('adviser_practice_name', practice);
  }

  const clean = window.location.pathname + (window.location.hash || '');
  window.history.replaceState({}, '', clean);
}

/** Amber dev toggles and localhost-only debug controls (webpack / local dev, not the offline shortcut). */
export function shouldShowLocalDevChrome() {
  if (typeof window === 'undefined') return false;
  if (isPresentationMode()) return false;
  const h = window.location.hostname;
  return (h === 'localhost' || h === '127.0.0.1') && !h.includes('supercalcpro');
}

/** Offline desktop shortcut: local server + presentation flag. */
export function isOfflineAdviserShortcut() {
  if (typeof window === 'undefined') return false;
  if (!isPresentationMode()) return false;
  const h = window.location.hostname;
  return (h === 'localhost' || h === '127.0.0.1') && !h.includes('supercalcpro');
}

/** True on the local offline demo server (with or without ?presentation=1). */
export function isOfflineLocalServer() {
  if (typeof window === 'undefined') return false;
  const h = window.location.hostname;
  const port = String(window.location.port || '');
  return (h === 'localhost' || h === '127.0.0.1') &&
    !h.includes('supercalcpro') &&
    port === '8765';
}
